import deepmerge from 'deepmerge';
import { createExact } from '../utilities.mjs';
import { metaThemeBase } from './base.mjs';

var createMetaThemeVariantPartial = createExact();
function createMetaThemeVariant(metaThemeVariantPartial) {
  return deepmerge(metaThemeBase, metaThemeVariantPartial);
}

export { createMetaThemeVariant, createMetaThemeVariantPartial };
